import type { IColumnInfo } from '@dbl/core/dataSource';
/**
 * @module utils/constants
 * @description 枚举、映射、默认值、debounce 时间等常量
 *
 * 数据流：
 *   UI 组件 / Hooks / convert() 引用这些常量进行校验和默认值设置
 *
 * 关键：
 * - notCalculateKey：在 `manifest/groupRegistryDefs` 标注 `recalcOnConfirm: false`，由 `manifest/recalcPolicy.ts` 派生
 * - ChartTypeDefaultUnit：各图表类型的默认数值单位
 */

/** Debounce 时间（毫秒）：QB 变化检测间隔 */
export const COMPARE_STATES_DEBOUNCE = 500;

/** Debounce 时间（毫秒）：图标可见性重新计算 */
export const ICON_VISIBILITY_DEBOUNCE = 300;

/** 折线/柱状等 X 轴 TopN 默认数量 */
export const DEFAULT_TOPN_COUNT = 5;

/** 条形图 Y 轴 TopN 默认数量 */
export const DEFAULT_HORIZONTAL_BAR_TOPN_COUNT = 20;

/** 默认 TopN「其它」展示文案 */
export const DEFAULT_TOPN_SHOW_OTHERS = 'and others';

/** 堆叠层 TopN 默认数量 */
export const DEFAULT_STACKED_COUNT = 20;

/** 折线图展示限制（stackedCount）默认数量 */
export const DEFAULT_DISPLAY_LIMIT_COUNT = 10;

/** 词云默认最大数量 */
export const DEFAULT_WORDCLOUD_COUNT = 30;

/** 面板宽度 (px) */
export const PANEL_WIDTH = 350;

/**
 * QB 列列表（IColumnInfo[]）在 model 未就绪时的稳定空数组默认值。
 *
 * 在 `useQuerySelector` / `useChartSettingsSelector` 的 selector 中对
 * `columnDimensions`、`columnMetrics`、`columnFilters` 等可能为 undefined 的字段兜底时使用。
 *
 * 勿在 selector 内写 `?? []`：每次 new 数组会导致 `shallowEqual` 误判并重渲染。
 *
 * @stable 禁止 mutate 本数组。
 */
export const EMPTY_COLUMN_INFO_LIST: readonly IColumnInfo[] = [];
